export enum EventType {
  Activity = 'Activity',
  Session = 'Session',
  Exam = 'Exam',
  PersonalEvent = 'PersonalEvent',
}

export enum InterventionPlace {
  NotSet = 'NotSet',
  InPerson = 'InPerson',
  Online = 'Online',
  OnlineTeacher = 'OnlineTeacher',
  Outside = 'Outside',
}

export interface EventLocation {
  libelle: string;
  code: string;
}

export interface BaseEvent {
  id: string;
  type: EventType;
  start: string;
  end: string;
  label: string;
  description?: string;
  locations?: EventLocation[];
}

export interface ActivityEvent extends BaseEvent {
  type: EventType.Activity;
  teamsLink?: string;
  zoomLink?: string;
  moodleLink?: string;
  teacher?: string;
  interventionPlace?: InterventionPlace;
  interventionPlaceAddress?: string;
  moreInfo?: string;
}

export interface SessionEvent extends BaseEvent {
  type: EventType.Session;
}

export interface ExamEvent extends BaseEvent {
  type: EventType.Exam;
}

export interface PersonalEvent extends BaseEvent {
  type: EventType.PersonalEvent;
  isMine: boolean;
  rsvp?: boolean;
  teamsLink?: string;
  attendees?: string[];
}

export type CalendarEvent = ActivityEvent | SessionEvent | ExamEvent | PersonalEvent;

export interface CalendarInterval {
  start: string;
  end: string;
}

export interface AppointmentSubmission {
  label: string;
  description?: string;
  start: string;
  end: string;
  locations?: EventLocation[];
  attendees?: string[];
  isOnlineMeeting?: boolean;
}

export interface DisplayEvent {
  displayId: string;
  originalEvent: CalendarEvent;
  isDisplaySegment?: boolean;
  dayIndex?: number;
  isFirstDay?: boolean;
  isLastDay?: boolean;
  id: string;
  type: EventType;
  start: string;
  end: string;
  label: string;
  description?: string;
  locations?: EventLocation[];
}

export interface CreatePersonalEventRequest {
  Title: string;
  Description?: string;
  Start: string;
  End: string;
  LocationName: string;
  Attendees: string[];
  IsOnlineMeeting?: boolean;
}

export interface PersonalEventApiResponse {
  id: string;
  start: string;
  end: string;
  visioTeams: boolean;
  teamsUrl: string | null;
  title: string;
  description: string;
  locations: EventLocation[];
  attendees: Array<{
    required: boolean;
    mail: string;
    fullname: string;
    isMe: boolean;
    responseType: string;
  }>;
  isOrganizer: boolean;
  isCanceled: boolean;
}

export interface ActivityApiResponse {
  type: 'Activity';
  id: string;
  start: string;
  end: string;
  label: string;
  description?: string;
  locations?: EventLocation[];
  teamsLink?: string;
  zoomLink?: string;
  moodleLink?: string;
  teacher?: string;
  interventionPlace?: InterventionPlace;
  interventionPlaceAddress?: string;
  moreInfo?: string;
}

export interface SessionApiResponse {
  type: 'Session';
  id: string;
  start: string;
  end: string;
  label: string;
  description?: string;
  locations?: EventLocation[];
}

export interface AgendaApiResponse {
  personalEvents: PersonalEventApiResponse[];
  activities: ActivityApiResponse[];
  sessions: SessionApiResponse[];
}

export enum RsvpStatus {
  Accept = 'Accept',
  Decline = 'Decline',
}
